import CollectionPage from "./CollectionPage";
export default CollectionPage;